import axios from 'axios';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { StaticPage } from './StaticPage';
import { useParams } from 'react-router-dom';

export const ReferencesPage = () => {
  const [references, setReferences] = useState([]);
  const { i18n, t } = useTranslation();
  const { lang: urlLang } = useParams<{ lang: string }>();
  const lang = i18n.language || urlLang;

  useEffect(() => {
    const getData = async () => {
      const response = await axios.get(`/references/${lang}.json`, {
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      });
      if (response.data) {
        setReferences(response.data);
      }
    };
    getData();
  }, [lang]);

  return (
    <StaticPage>
      <h1>{t('references.header')} </h1>
      {references.map((el, i) => (
        <p key={i}>{el}</p>
      ))}
    </StaticPage>
  );
};
